import { render, staticRenderFns } from "./OnboardingActivity.vue?vue&type=template&id=23764402&scoped=true&"
import script from "./OnboardingActivity.vue?vue&type=script&lang=js&"
export * from "./OnboardingActivity.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingActivity.vue?vue&type=style&index=0&id=23764402&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23764402",
  null
  
)

export default component.exports